module.exports = __webpack_public_path__ + "assets/img/shop_tit.1cbcc356.png";